import {
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react"

import SearchIcon from "components/icons/search_icon"
import XCircleIcon from "components/icons/xcircle_icon"

import { SearchTypeProps } from "./types"

const CustomSearch = (props: SearchTypeProps) => {
  const {
    onClear,
    setTerm,
    term,
    width = "xs",
    inputHeight = "40px",
    borderRadius = "full",
    placeHolder = "Search for...",
    placeHolderColor = "#00000077",
  } = props
  return (
    <InputGroup borderColor='transparent' w={width} height='42px'>
      <InputLeftElement
        pl='8px'
        pointerEvents='none'
        fontSize='1.2em'
        h={inputHeight}
      >
        <SearchIcon fill='#9D9696' />
      </InputLeftElement>
      <Input
        placeholder={placeHolder}
        value={term}
        onChange={(e) => setTerm(e.target.value)}
        border='1.5px solid #e1e1e1'
        borderColor='#e1e1e1'
        borderRadius={borderRadius}
        h={inputHeight}
        _placeholder={{ color: placeHolderColor }}
        _focus={{
          borderColor: "secondaryColor",
          outline: "1.5px solid",
          outlineOffset: "0px",
          outlineColor: "secondaryColor",
        }}
        _hover={{}}
      />
      {term && (
        <InputRightElement h={inputHeight}>
          <IconButton
            onClick={() => onClear()}
            aria-label='clear input'
            variant='ghost'
            icon={<XCircleIcon />}
          />
        </InputRightElement>
      )}
    </InputGroup>
  )
}

export default CustomSearch
